import { FC } from "react";
import { DropsButton, Text } from "shared/components/Spor";
import {
  ArrowDownOutline18Icon,
  ArrowUpOutline18Icon,
} from "@vygruppen/spor-icon-react";
import styled from "styled-components";

export const TRAIN_LIMIT = 10;

const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
`;

const Third = styled.div<{ $align: string }>`
  flex-basis: 1fr;

  display: flex;
  justify-content: ${({ $align }) => $align};
`;

type ActionableTrainSectionFooterProps = {
  toggleAll: () => void;
  showAll: boolean;
  currentLength: number;
  totalLength: number;
};

export const ActionableTrainSectionFooter: FC<
  ActionableTrainSectionFooterProps
> = ({ toggleAll, showAll, currentLength, totalLength }) => (
  <Wrapper>
    <Third $align="flex-start">&nbsp;</Third>

    <Third $align="center">
      {totalLength > TRAIN_LIMIT && (
        <DropsButton
          variant={showAll ? "secondary" : "tertiary"}
          size="xs"
          rightIcon={
            showAll ? <ArrowUpOutline18Icon /> : <ArrowDownOutline18Icon />
          }
          onClick={toggleAll}
        >
          {showAll ? "Vis færre" : "Vis alle"}
        </DropsButton>
      )}
    </Third>

    <Third $align="flex-end">
      <Text variant="sm" color="textSecondary">
        Viser {currentLength} av {totalLength}
      </Text>
    </Third>
  </Wrapper>
);
